<template>
  <div id="login-layer">
    <div class="top-logo">
      <div v-if="lg == 'asjy'">
        <img :src="asjylogoDarkSrc" class="login-logo" alt="" ondragstart="return false" />
      </div>
      <img :src="logoDarkSrc" class="login-logo" alt="" ondragstart="return false" />
<!--      <div>电子合同服务平台</div>-->
    </div>
    <div class="login-content">
      <div class="login-main-layer">
        <div class="login-imgs">
          <div class="code-imgs clearfix"></div>
          <img src="../assets/images/login/login-bg-text.png" class="login-text-img" alt="" />
          <img src="../assets/images/login/stripe.png" class="login-stripe" alt="" ondragstart="return false" />
        </div>
        <div class="login-main-box">
          <div class="welcome">
            {{ status == "login" ? "欢迎使用电子合同服务平台" : "注册账号" }}
          </div>
          <div v-show="status == 'login'">
            <el-tabs v-model="active" @tab-click="handleChangeTab" :class="{ 'captcha-wrap': method == 'pwd' }">
              <el-tab-pane label="个人账户" name="person"></el-tab-pane>
              <el-tab-pane label="企业账户" name="company"></el-tab-pane>
            </el-tabs>
            <el-form :model="loginForm" :rules="loginFormRules" ref="loginForm" @keyup.enter.native="logIn">
              <el-form-item label="" prop="account" v-if="method == 'sms'">
                <el-input placeholder="请输入手机号" maxlength="11" v-model="loginForm.account">
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="account" v-else>
                <el-input :placeholder="active == 'person' ? '请输入个人账号' : '请输入企业账号'
                  " maxlength="25" v-model="loginForm.account">
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="password" v-if="method == 'pwd'">
                <el-input placeholder="请输入登录密码（8-14位数字和字母组合）" maxlength="14" v-model="loginForm.password" type="password">
                </el-input>
              </el-form-item>
              <el-form-item prop="vcode" v-else>
                <el-input class="vcode-ipt" placeholder="输入验证码" maxlength="6" v-model="loginForm.vcode"></el-input>
                <div class="code-btn">
                  <el-button type="primary" plain :disabled="!sendAuthCode" @click="getMsgAuthCode('login')"
                    v-show="sendAuthCode">获取验证码
                  </el-button>
                  <el-button type="primary" plain v-show="!sendAuthCode">{{ auth_time }}秒</el-button>
                </div>
              </el-form-item>
              <el-form-item prop="imgCode" v-if="method == 'pwd'">
                <el-input class="captcha-ipt" placeholder="输入验证码" maxlength="4" v-model="loginForm.imgCode"></el-input>
                <div class="code-btn">
                  <img :src="captchaImg" @click="handleGetCaptchaImage" class="captcha-img" alt=""
                    ondragstart="return false" />
                </div>
              </el-form-item>

              <div class="flex tip">
                <span>
                  <span>没有账号？<span class="link" @click="switchLoginRegister('register')"
                      style="cursor: pointer">立即注册</span></span>
                </span>
                <span>
                  <!-- <router-link class="link" to="/register">忘记密码？</router-link> -->
                </span>
              </div>
              <div class="flex tip login-agreement">
                <el-checkbox v-model="loginPrivacyChecked">
                  我已阅读并同意<a :href="privacyAgreementUrl" target="_blank" class="link">《服务协议》</a><a
                    :href="userAgreementUrl" target="_blank" class="link">《用户使用协议》</a>
                </el-checkbox>
                <div style="padding-left: 18px">
                  <a :href="privacyPolicyUrl" target="_blank" class="link">《用户隐私政策》</a>
                  <a :href="certPolicyUrl" target="_blank" class="link">《电子认证服务协议》</a>
                </div>
                <div v-show="showLoginPrivacyWarn" role="tooltip" class="el-popover el-popper el-popover--plain"
                  tabindex="0" style="transform-origin: center bottom" x-placement="top-start">
                  请先阅读并勾选《服务协议》《用户使用协议》《用户隐私政策》《电子认证服务协议》。
                  <div x-arrow="" class="popper__arrow" style="left: 32.5px"></div>
                </div>
              </div>
              <div class="bottom">
                <el-button type="primary" class="bottom-btn" @click="logIn">登 录</el-button>
                <el-button type="text" class="txt-btn" @click="switchSmsLogin">{{ method == "pwd" ? "短信登录" : "账号登录" }}
                </el-button>
              </div>
            </el-form>
          </div>
          <div v-show="status == 'register' && !registered" class="register-form-wrap">
            <el-form class="register-form" :model="registerForm" :rules="registerFormRules" ref="registerForm"
              @keyup.enter.native="submitRegister($event)">
              <!-- <div class="title">注册</div> -->
              <el-form-item label="请先选择账号类型" prop="userType" style="margin-bottom: 0" class="first-label">
                <el-radio-group v-model="registerForm.userType" @change="handleChangeRegisterUserType">
                  <el-radio label="person">个人</el-radio>
                  <el-radio label="company">企业</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="账号：" prop="userName">
                <div class="flex-just">
                  <!-- <div :contenteditable="userNameEdit" :class="{ isEdit: userNameEdit }" class="userNameIpt">{{
                    generatedUserName }}</div> -->
                  <div v-if="!userNameEdit" class="user-name">{{
                    registerForm.userName }}</div>
                  <el-input placeholder="请输入用户名" maxlength="25" v-model="registerForm.userName" v-else>
                  </el-input>
                  <el-button v-if="!userNameEdit" type="text" class="base-edit" icon="el-icon-edit"
                    @click="handleEditUserName" style="margin-left: 20px;">修改</el-button>
                  <el-button v-else type="text" class="base-edit" icon="el-icon-check" @click="handleCheckUserName"
                    style="margin-left: 20px;">确定</el-button>
                </div>

              </el-form-item>
              <el-form-item label="" prop="address">
                <el-input placeholder="请输入手机号" maxlength="11" v-model="registerForm.address">
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="vcode">
                <el-input class="vcode-ipt" placeholder="输入验证码" maxlength="6" v-model="registerForm.vcode"></el-input>
                <div class="code-btn">
                  <el-button type="primary" plain :disabled="!sendAuthCode" @click="getMsgAuthCode('register')"
                    v-show="sendAuthCode">获取验证码
                  </el-button>
                  <el-button type="primary" plain v-show="!sendAuthCode">{{ auth_time }}秒</el-button>
                </div>
              </el-form-item>
              <el-form-item label="" prop="password">
                <el-input placeholder="请输入登录密码（8-14位数字和字母组合）" maxlength="14" show-word-limit v-model="registerForm.password" type="password">
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="pin">
                <el-input placeholder="请输入签署密码（6位数字）" maxlength="6" show-word-limit v-model="registerForm.pin" type="password">
                </el-input>
              </el-form-item>
              <div class="flex tip">
                <el-checkbox v-model="privacyChecked">
                  我已阅读并同意<a :href="privacyAgreementUrl" target="_blank" class="link">《服务协议》</a><a
                    :href="userAgreementUrl" target="_blank" class="link">《用户使用协议》</a>
                </el-checkbox>
                <div style="padding-left: 18px">
                  <a :href="privacyPolicyUrl" target="_blank" class="link">《用户隐私政策》</a>
                  <a :href="certPolicyUrl" target="_blank" class="link">《电子认证服务协议》</a>
                </div>
                <div v-show="showPrivacyWarn" role="tooltip" class="el-popover el-popper el-popover--plain" tabindex="0"
                  style="transform-origin: center bottom" x-placement="top-start">
                  请先阅读并勾选《服务协议》《用户使用协议》《用户隐私政策》《电子认证服务协议》。
                  <div x-arrow="" class="popper__arrow" style="left: 32.5px"></div>
                </div>
              </div>
              <div class="bottom">
                <el-button type="primary" :loading="loading" class="bottom-btn" @click="submitRegister($event)">提 交
                </el-button>
                <el-button type="text" class="txt-btn" @click="switchLoginRegister('login')">已有账号登录</el-button>
              </div>
            </el-form>
          </div>
          <div class="register-success" v-show="registered">
            <div class="title">注册成功</div>
            <img src="../assets/images/feedback-success.png" alt="" />
            <div class="tip">恭喜您注册成功，请重新登录</div>
            <div class="jump">
              <span class="blue"></span>
              <span>{{ countdown }}秒后跳转至登录页</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-dialog append-to-body :close-on-click-modal="false" :close-on-press-escape="false" title="选择企业账号登录"
      :visible.sync="selectCompanyDialogVisible" width="500px">
      <el-select size="small" v-model="selectedCompany" placeholder="请选择" style="width: 300px;">
        <el-option v-for="item in companyOptions" :key="item.tenantId" :label="item.companyName + '(' + item.userId + ')'"
          :value="item.tenantId">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSelectCompany">确 定</el-button>
      </span>
    </el-dialog> -->


    <el-dialog title="选择企业账号登录" :visible.sync="selectCompanyDialogVisible" width="790px" append-to-body
      :close-on-click-modal="false" custom-class="select-dialog">
      <div style="padding-bottom: 25px">
        <el-table :data="toSelectCompanyAccountList" style="width: 100%">
          <el-empty description="暂无数据" slot="empty"></el-empty>
          <el-table-column label="选择" prop="check" width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.check" @change="handleSelectionChange(scope.row.userId)"></el-checkbox>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="companyName" label="企业名称" v-if="userContact.queryParams.subject == 'company'"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="scope-content" v-if="scope.row.subject == 'company'">
                <span>{{ scope.row.companyName }}</span>
              </div>
              <div class="scope-content" v-else>
                <span>-</span>
              </div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="subject" label="联系人类型">
            <template slot-scope="scope">
              <div class="scope-content">
                <span>{{
                scope.row.subject == "person" ? "个人" : "企业"
                }}</span>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="userId" label="账号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="companyName" label="企业名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="authStatus" label="状态" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.authStatus == 'passAuth'">已认证</span>
              <span v-if="scope.row.authStatus == 'inPersonAuth' || scope.row.authStatus == 'inCompanyAuth'">认证中</span>
              <span
                v-if="scope.row.authStatus == 'rejectPersonAuth' || scope.row.authStatus == 'rejectCompanyAuth'">认证失败</span>
              <span v-if="scope.row.authStatus == 'notAuth'">未认证</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="注册时间" show-overflow-tooltip>
            <template slot-scope="scope">
              <div>{{ scope.row.createTime.split(" ")[0] }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSelectCompany(undefined, $event)" size="small">确定</el-button>
      </div>
    </el-dialog>


    <e-footer></e-footer>
  </div>
</template>
<script>
import eFooter from "@/components/eFooter";
import { getCaptchaImage, getsmsCodeApi } from "@/api/common";
import { registerApi, checkPhoneAccount, formRandomUserName, checkAccountUnique, phoneCompanyInfoList } from "@/api/register";
import {
  setTenantIdApi,
} from "@/api/home";
import { setToken } from "@/utils/auth";
import Cookies from "js-cookie";
export default {
  components: {
    eFooter,
  },
  data() {
    // 校验手机号格式
    var checkPhone = (rule, value, callback) => {
      var phoneReg = /^1[3456789]\d{9}$/;
      if (!phoneReg.test(value)) {
        callback(new Error("请输入正确手机号！"));
      } else {
        callback();
      }
    };

    // 密码正则
    var passwordReg = (rule, value, callback) => {
      var pReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,14}$/;
      if (!pReg.test(value)) {
        callback(new Error("请输入8-14位数字和字母组合（区分大小写）"));
      } else {
        callback();
      }
    };

    // 签署密码正则
    var pinReg = (rule, value, callback) => {
      var pReg = /^[0-9]\d{5}$/;
      if (!pReg.test(value)) {
        callback(new Error("签署密码为六位数字"));
      } else {
        callback();
      }
    };

    var userNameReg = (rule, value, callback) => {
      var pReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{5,25}$/;
      if (!pReg.test(value)) {
        callback(new Error("账号必须由5~25位的字母和数字组成！"));
      } else {
        callback();
      }
    };

    return {
      logoDarkSrc: ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) + "pc/logo-dark.png",
      asjylogoDarkSrc: ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) + "pc/logoDir/asjy.png",
      privacyAgreementUrl:
        ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) +
        "common/agreement/service-agreement.html",
      userAgreementUrl:
        ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) +
        "common/agreement/user-agreement.html",
      privacyPolicyUrl:
        ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) +
        "common/agreement/privacy-policy.html",
      certPolicyUrl:
              ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) +
              "common/agreement/cert-policy.html",
      active: "person",
      method: "sms",
      status: "login",
      privacyChecked: false,
      loginPrivacyChecked: false,
      showLoginPrivacyWarn: false,
      showPrivacyWarn: false,
      registered: false,
      captchaImg: "",
      captchaImgUUid: "",

      showWechatCode: false,
      loading: false,
      stitle: "",
      itemActive: "account",
      countdown: 3,

      loginForm: {
        account: "",
      },
      registerForm: {
        userType: "person",
        userName: "",
        vcode: "",
        address: "",
        password: "",
      },
      registerFormRules: {
        address: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
        password: [
          { validator: passwordReg, trigger: 'blur',message: "请输入8-14位数字和字母组合（区分大小写）"}
        ],
        pin: [
          { validator: pinReg, trigger: 'blur',message: "签署密码为六位数字"}
        ],
        vcode: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
        userName: [
          { validator: userNameReg, trigger: 'blur' }
        ],
      },
      loginFormRules: {
        account: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
        vcode: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
        imgCode: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
      },
      codeImg: "",
      sendAuthCode: true,
      auth_time: 1,
      auth_timetimer: null,
      imgCodeUUid: "",
      sign: "",
      random: "",
      randomId: "",
      dialogVisible: false,
      accountList: [],
      generatedUserName: {
        "person": "",
        "company": ""
      },
      userNameEdit: false,
      selectCompanyDialogVisible: false,
      // selectedCompany: undefined,
      multipleSelection: undefined,
      toSelectCompanyAccountList: [],
      lg : undefined
      // companyOptions: []
    };
  },
  created() {
    this.lg = this.$route.query.lg;
  },
  mounted() { },
  watch: {
    status(newV) {
      if (newV == "register" && !this.generatedUserName[this.registerForm.userType]) {
        formRandomUserName({
          userType: this.registerForm.userType
        }).then(res => {
          this.registerForm.userName = this.generatedUserName[this.registerForm.userType] = res.data.userName;
        })
      } else {
        this.userNameEdit = false;
        this.registerForm.userName = this.generatedUserName[this.registerForm.userType];
      }
    }
  },
  methods: {
    handleChangeRegisterUserType() {
      if (!this.generatedUserName[this.registerForm.userType]) {
        formRandomUserName({
          userType: this.registerForm.userType
        }).then(res => {
          this.registerForm.userName = this.generatedUserName[this.registerForm.userType] = res.data.userName;
        })
      } else {
        this.registerForm.userName = this.generatedUserName[this.registerForm.userType]
      }
    },
    handleSelectionChange(val) {
      this.toSelectCompanyAccountList.map((_item) => {
        if (_item.userId === val) {
          _item.check = true;
          this.multipleSelection = _item;
        } else {
          _item.check = false;
        }
      });
    },
    handleCheckUserName() {
      this.$refs.registerForm.validateField("userName", (error) => {
        if (!error) {
          checkAccountUnique({
            userName: this.registerForm.userName
          }).then(res => {
            if (res.code != 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "warning",
              });
            } else {
              if (res.data.result == "ok") {
                this.userNameEdit = false;
                this.$message({
                  showClose: true,
                  message: "验证通过",
                  type: "success",
                });
              } else {
                this.$message({
                  showClose: true,
                  message: "已被注册",
                  type: "warning",
                });
              }
            }
          })
        }
      })
    },
    handleEditUserName() {
      this.userNameEdit = true
    },
    getMsgAuthCode(type) {
      let form = "loginForm";
      let field = "account";
      if (type == "register") {
        form = "registerForm";
        field = "address";
      }
      this.$refs[form].validateField(field, (error) => {
        if (!error) {
          if (type == "register" && this.registerForm.userType == "person") {
            checkPhoneAccount({
              phone: this.registerForm.address,
              userType: this.registerForm.userType
            }).then(res => {
              if (res.code != 200) {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });
              } else {
                if (res.data.result == 'ok') {
                  getsmsCodeApi({
                    address: this[form][field],
                    bizType: type == "register" ? type : "login",
                  }).then((res) => {
                    console.log(res);
                    if (res.code != 200) {
                      this.$message({
                        showClose: true,
                        message: res.message,
                        type: "warning",
                      });
                    } else {
                      this.$message({
                        message: "短信发送成功",
                        type: "success",
                      });
                      // 倒计时
                      this.sendAuthCode = false;
                      this.auth_time = 60;
                      let auth_timetimer = setInterval(() => {
                        this.auth_time--;
                        if (this.auth_time <= 0) {
                          this.sendAuthCode = true;
                          clearInterval(auth_timetimer);
                        }
                      }, 1000);
                    }
                  });
                } else {
                  this.$message({
                    showClose: true,
                    message: "您的手机号已经注册过个人账号，不允许重复注册，请直接登录",
                    type: "warning",
                  });
                }

              }
            })
            return;
          }

          if (type == "login") {
            checkPhoneAccount({
              phone: this.loginForm.account,
              userType: this.active
            }).then(res => {
              if (res.code != 200) {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });
              } else {
                if (res.data.result == 'no') {
                  getsmsCodeApi({
                    address: this[form][field],
                    bizType: type == "register" ? type : "login",
                  }).then((res) => {
                    console.log(res);
                    if (res.code != 200) {
                      this.$message({
                        showClose: true,
                        message: res.message,
                        type: "warning",
                      });
                    } else {
                      this.$message({
                        message: "短信发送成功",
                        type: "success",
                      });
                      // 倒计时
                      this.sendAuthCode = false;
                      this.auth_time = 60;
                      let auth_timetimer = setInterval(() => {
                        this.auth_time--;
                        if (this.auth_time <= 0) {
                          this.sendAuthCode = true;
                          clearInterval(auth_timetimer);
                        }
                      }, 1000);
                    }
                  });
                } else {
                  this.$message({
                    showClose: true,
                    message: `当前手机号未注册${this.active == 'person' ? '个人' : '企业'}账号`,
                    type: "warning",
                  });
                }

              }
            })
          }

          if (type == "register" && this.registerForm.userType == "company") {
            getsmsCodeApi({
              address: this[form][field],
              bizType: type == "register" ? type : "login",
            }).then((res) => {
              console.log(res);
              if (res.code != 200) {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });
              } else {
                this.$message({
                  message: "短信发送成功",
                  type: "success",
                });
                // 倒计时
                this.sendAuthCode = false;
                this.auth_time = 60;
                let auth_timetimer = setInterval(() => {
                  this.auth_time--;
                  if (this.auth_time <= 0) {
                    this.sendAuthCode = true;
                    clearInterval(auth_timetimer);
                  }
                }, 1000);
              }
            });
          }

        }
      });
    },
    switchSmsLogin() {
      this.resetForm("login", true);
      if (this.method == "sms") {
        this.method = "pwd";
        this.handleGetCaptchaImage();
        return;
      }
      if (this.method == "pwd") {
        this.method = "sms";
      }
    },
    switchLoginRegister(option) {
      this.status = option;
      this.sendAuthCode = true;
      this.auth_time = 60;
      clearInterval(this.auth_timetimer);
      this.resetForm(option);
    },
    handleChangeTab() { },
    submitRegister(e) {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          if (!this.privacyChecked) {
            let _this = this;
            this.showPrivacyWarn = true;
            e.preventDefault();
            e.stopPropagation();
            function handler() {
              _this.showPrivacyWarn = false;
              document.documentElement.removeEventListener("click", handler);
            }
            document.documentElement.addEventListener("click", handler);
            return;
          }
          this.loading = true;
          let params = {
            address: this.registerForm.address,
            vcode: this.registerForm.vcode,
            password: this.registerForm.password,
            userType: this.registerForm.userType,
            pin: this.registerForm.pin,
            userName: this.registerForm.userName
          };
          // if (Cookies.get("inviteCode")) {
          //   params.userInviteCode = Cookies.get("inviteCode");
          // }
          // 邀请码从链接中获取
          if(this.$route.query.ic){
            // alert("项目邀请码：" + this.$route.query.ic)
            params.userInviteCode = this.$route.query.ic;
          }

          registerApi(params).then((res) => {
            if (res.code != 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "warning",
              });
              this.loading = false;
              this.registered = false;
            } else {
              this.$message({
                message: "注册成功",
                type: "success",
              });
              this.loading = false;
              this.registered = true;
              setToken(res.data.token, 1);
              this.$router.push({
                path: "/",
              });
              this.$store.commit("SET_USER_CONTRSCT_INFO", {});
              this.$store.commit("SET_COMPSNYL_LIST", {});
              this.$store.commit("SET_CURRENT_SPACE", {});
              // let timer = setInterval(() => {
              //   this.countdown--;
              //   if (this.countdown <= 0) {
              //     clearInterval(timer);
              //     this.resetForm("register");
              //     this.switchLoginRegister("login");
              //     this.countdown = 3;
              //     this.registered = false;
              //   }
              // }, 1000);
            }
          });
        } else {
          this.loading = false;
          console.log("error submit!");
          return false;
        }
      });
    },
    resetForm(type, noChangeFlag) {
      if (type == "login") {
        this.loginForm = {
          account: "",
        };
        this.$refs["loginForm"].resetFields();
      } else {
        this.privacyChecked = false;
        this.registerForm = {
          userName: "",
          userType: this.active,
          vcode: "",
          address: "",
          password: "",
        };
        this.$refs["registerForm"].resetFields();
      }
      !noChangeFlag && (this.active = this.registerForm.userType);
    },
    logIn(e) {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          if (!this.loginPrivacyChecked) {
            let _this = this;
            this.showLoginPrivacyWarn = true;
            e.preventDefault();
            e.stopPropagation();
            function handler() {
              _this.showLoginPrivacyWarn = false;
              document.documentElement.removeEventListener("click", handler);
            }
            document.documentElement.addEventListener("click", handler);
            return;
          }
          this.loading = true;

          const user = {
            userType: this.active,
          };
          if (this.method == "pwd") {
            user.password = this.loginForm.password;
            user.account = this.loginForm.account;
            user.imgUuid = this.captchaImgUUid;
            user.imgCode = this.loginForm.imgCode;
          } else {
            user.address = this.loginForm.account;
            user.vcode = this.loginForm.vcode;
          }
          const method = this.method === "sms" ? "vcodeLogin" : "accountLogin";

          if (this.method === "sms" && this.active === "company") {
            // 返回企业列表
            phoneCompanyInfoList({
              phone: this.loginForm.account,
              vcode: this.loginForm.vcode
            }).then(res => {
              if (res.code != 200) {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });
              } else {
                // 如果只有一个账号，则直接登录
                if (res.data.resultList.length > 1) {
                  res.data.resultList.map((item) => {
                    item.check = false;
                  });
                  this.toSelectCompanyAccountList = res.data.resultList;
                  this.selectCompanyDialogVisible = true;
                } else {
                  if (res.data.resultList[0]) {
                    this.handleSelectCompany(res.data.resultList[0], undefined);
                  }
                }

              }
            })
          } else {
            this.$store
              .dispatch(method, user)
              .then(() => {
                this.loading = false;
                this.$router.push({
                  path: "/",
                });
                // 登录初始化清空
                this.$store.commit("SET_USER_INFO", {});
                this.$store.commit("SET_USER_CONTRSCT_INFO", {});
                this.$store.commit("SET_COMPSNYL_LIST", {});
                this.$store.commit("SET_CURRENT_SPACE", {});
                this.$store.commit("SET_SPACE_INFO_LIST", []);
              })
              .catch((message) => {
                this.$message({
                  showClose: true,
                  message: message,
                  type: "warning",
                });
                this.handleGetCaptchaImage();
                this.loading = false;
              });
          }


        } else {
          console.log("error submit!");
          return false;
        }
      });
    },

    handleSelectCompany(multipleSelection = this.multipleSelection) {
      if (!multipleSelection) {
        this.$message({
          showClose: true,
          message: "请先选择企业账号",
          type: "warning",
        });
        return;
      }
      this.loading = true;
      const user = {
        userType: "company",
        address: this.loginForm.account,
        vcode: this.loginForm.vcode,
        tenantId: multipleSelection.tenantId
      };
      this.$store
        .dispatch("vcodeLogin", user)
        .then(() => {
          this.loading = false;
          this.selectCompanyDialogVisible = false;
          this.$router.push({
            path: "/",
          });
          this.$store.commit("SET_USER_CONTRSCT_INFO", {});
          this.$store.commit("SET_COMPSNYL_LIST", {});
          this.$store.commit("SET_CURRENT_SPACE", {});
        })
        .catch((message) => {
          this.$message({
            showClose: true,
            message: message,
            type: "warning",
          });
          this.handleGetCaptchaImage();
          this.loading = false;
        });


    },

    getCookie() {
      const username = Cookies.get("username");
      let password = Cookies.get("password");
      const rememberMe = Cookies.get("rememberMe");
      // 保存cookie里面的加密后的密码
      this.cookiePass = password === undefined ? "" : password;
      password =
        password === undefined ? this.accountRuleForm.password : password;
      this.accountRuleForm = {
        accountphone:
          username === undefined ? this.accountRuleForm.accountphone : username,
        accountpassword: password,
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe),
        accountcode: "",
      };
    },
    handleGetCaptchaImage() {
      getCaptchaImage().then((res) => {
        this.captchaImg = res.data.img;
        this.captchaImgUUid = res.data.uuid;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.top-logo {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9;
  padding: 34px 52px;
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 400;
  color: #292d40;

  img {
    display: block;
    width: auto;
    height: 40px;
    margin-right: 19px;
  }
}

.login-content {
  width: 100%;
  height: 100vh;
  background: url("../assets/images/login/login-bg.png") no-repeat;
  background-size: cover;
  overflow: hidden;
  position: relative;

  .login-main-layer {
    // width: 80%;
    // height: calc(100vh - 71px);
    // margin: 0 auto;
    // position: relative;
    max-width: 1143px;
    height: 555px;
    background: #ffffff;
    box-shadow: 0px 3px 32px 0px rgba(50, 150, 250, 0.13);
    border-radius: 8px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    overflow: hidden;

    .login-imgs {
      position: absolute;
      left: 0;
      top: 0;
      width: calc(100% - 446px);
      height: 555px;
      background: linear-gradient(0deg, #2f45cd 0%, #68adfc 100%);

      .login-text-img {
        display: block;
        width: 400px;
        height: auto;
        margin: 160px auto 0;
      }

      .login-stripe {
        display: block;
        width: 632px;
        height: auto;
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }

    .login-main-box {
      width: 446px;
      height: 100%;
      padding: 40px 55px 57px;
      background: #ffffff;
      position: absolute;
      right: 0;
      /* top: 198px; */
      top: 0;

      .welcome {
        font-size: 20px;
        font-weight: 400;
        color: #292d40;
        text-align: center;
        margin-bottom: 40px;
      }

      // & > div {
      // 	height: 100%;
      // }
      .el-tabs {
        &.captcha-wrap /deep/ .el-tabs__header {
          padding-bottom: 11px;
        }

        /deep/ .el-tabs__header {
          padding-bottom: 23px;

          .el-tabs__nav-wrap::after {
            content: "";
            display: none;
          }

          .el-tabs__nav {
            width: 100%;
            float: unset;
            display: flex;
            justify-content: space-around;
          }

          .el-tabs__item {
            width: 50%;
            text-align: center;
            padding: 0;
          }

          .el-tabs__active-bar {
            width: 50px !important;
            margin-left: calc(25% - 25px);
          }
        }
      }

      .login-main-item {
        width: 400px;
      }

      .el-form {
        width: 100%;

        .el-form-item {
          margin-bottom: 15px;
          margin-right: 0;

          /deep/ .el-form-item__content {
            line-height: 40px;
          }
        }

        /deep/ .el-form-item__error {
          padding-top: 2px;
        }
      }

      .tip {
        font-size: 13px;
        margin-top: -4px;
        position: relative;

        .link {
          color: #3296fa;
        }
      }

      .vcode-ipt {
        width: calc(100% - 100px);
      }

      .captcha-ipt {
        width: calc(100% - 110px);
      }

      .code-btn {
        .el-button {
          background: #ffffff;
          width: 90px;
          height: 40px;
          border: 1px solid #3296fa;
          color: #3296fa;
          border-radius: 3px;
          padding: 0;

          /deep/ span {
            font-size: 13px;
            font-weight: 400;
          }
        }

        img {
          display: block;
          cursor: pointer;
        }
      }

      .login-agreement {
        position: absolute;
        // width: 100%;
        left: 0;
        bottom: 110px;
        margin: 0 55px;
      }

      .el-popover {
        position: absolute;
        left: 0;
        top: -83px;
        transition: opacity 0.3s ease;
      }

      .bottom {
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 16px;
        padding: 0 55px;
        height: 80px;

        .bottom-btn {
          width: 100%;
          // position: absolute;
          // left: 0;
          // bottom: 0;
        }

        .txt-btn {
          margin: 0 auto;
          display: block;
          padding: 12px 20px;
        }
      }

      .register-form-wrap {
        margin-top: -15px;
      }

      .register-form {
        .title {
          font-size: 15px;
          font-weight: bold;
          text-align: center;
          margin-bottom: 12px;
        }

        .first-label /deep/ .el-form-item__label {
          margin-right: 50px;
        }

        /deep/ .el-form-item__label {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          // width: 140px;
          height: 35px;
          line-height: 40px;
          text-align: left;
          margin-right: 0px;
        }

        /deep/ .el-checkbox__label {
          font-size: 13px;
        }

        .tip {
          // position: relative;

          position: absolute;
          left: 0;
          bottom: 110px;
          margin: 0 55px;

          .el-popover {
            position: absolute;
            left: 0;
            top: -83px;
            transition: opacity 0.3s ease;
          }
        }

        /deep/ .el-radio__inner {
          margin-top: -1px;
          display: inline-block;
          position: relative;
          border: 1px solid #DCDCDC;
          border-radius: 3px;
          box-sizing: border-box;
          width: 16px;
          height: 16px;
          z-index: 1;
          transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
            background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);

          &:hover {
            border-color: #3F7BF9;
          }

          &::after {
            box-sizing: content-box;
            content: "";
            border: 1.5px solid #ffffff;
            border-radius: 0;
            background-color: unset;
            border-left: 0;
            border-top: 0;
            height: 8px;
            left: 5px;
            position: absolute;
            top: 1px;
            transform: rotate(45deg) scaleY(0);
            width: 3px;
            transition: transform 0.15s ease-in 0.05s;
            transform-origin: center;
          }
        }

        /deep/ .el-radio__input.is-checked .el-radio__inner {
          border-color: #3F7BF9;
          background: #3F7BF9;
        }

        /deep/ .el-radio__input.is-checked .el-radio__inner::after {
          transform: rotate(45deg) scaleY(.8);

        }
      }

      .register-success {
        .title {
          font-size: 15px;
          font-weight: bold;
          color: #333333;
          text-align: center;
        }

        img {
          width: 153px;
          height: auto;
          display: block;
          margin: 73px auto 57px;
        }

        .tip {
          font-size: 13px;
          font-weight: 400;
          color: #333333;
          text-align: center;
          margin-bottom: 10px;
        }

        .jump {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          text-align: center;
        }

        .blue {
          color: #3296fa;
        }
      }
    }
  }
}

// @media screen and (min-width: 1200px) and (max-width: 1499px) {
// 	.login-main-layer {
// 		width: 70%;
// 	}
// }
// @media screen and (max-width: 1199px) {
// 	.login-main-layer {
// 		width: auto;
// 	}
// }

.code-item {
  width: 170px;
  text-align: center;
  height: 130px;
}

.code-item p {
  line-height: 30px;
  text-align: center;
  font-size: 14px;
}

// .login-main-box {
// 	width: 376px;
// 	height: 339px;
// 	padding: 32px 43px 49px;
// 	background: #ffffff;
// 	box-shadow: 0px 3px 38px 0px rgba(0, 0, 0, 0.13);
// 	border-radius: 10px;
// 	position: absolute;
// 	right: 0;
// 	/* top: 198px; */
// 	top: 50%;
// 	margin-top: -238px;
// }

.login-main-nav {
  width: 80%;
  /* display: flex;
																																																							        justify-content: space-between; */
  font-size: 18px;
  margin: 48px auto;
}

.login-main-nav a {
  color: #333333;
  padding-bottom: 5px;
  float: left;
  margin-right: 97px;
}

.login-main-nav a:last-child {
  margin-right: 0;
}

.login-main-nav a.active {
  color: #e85052;
  font-weight: 600;
  /* border-bottom: 2px solid #E85052; */
}

.login-main-pane {
  margin-top: 48px;
}

.login {
  width: 100%;
  height: 50px;
  font-size: 18px;
  margin-top: 45px;
}

.line {
  margin-top: 54px;
  background: #eeeeee;
  width: 100%;
  height: 1px;
}

.to-register:hover {
  text-decoration: underline;
}

.code-btn {
  position: absolute;
  right: 0;
  top: 0;
}

.code-btn button {
  height: 48px;
}

.msg-item {
  margin-top: 46px;
}

.account-item {
  margin-top: 49px;
}

.account-bottom {
  width: 401px;
  position: relative;
  color: #e85052;
  font-size: 16px;
  margin-bottom: 0px !important;
  margin-top: -15px;
}

.accountcode {
  display: flex;
  justify-content: space-between;
}

.code-img {
  display: block;
  width: 150px;
  height: 48px;
  position: absolute;
  right: 0;
  top: 0;
}

.to-register {
  margin-top: 12px;
  color: #e85052;
  font-size: 16px;
  text-align: right;
  display: block;
  width: 100%;
}

.account-layer {
  width: 400px;
  position: relative;
}

.account-layer .forget-password {
  position: absolute;
  left: 0;
  top: 5px;
  font-size: 16px;
  color: #e85052;
}

.account-layer .to-register {
  position: absolute;
  right: 0;
  top: 5px;
  font-size: 16px;
  color: #e85052;
  margin-top: 0;
}

.account-list-form {
  width: 260px;
  margin: 0 auto;
}

#account-list-layer .dialog-btns {
  width: 475px;
  margin: 40px auto 0;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}

.dialog-btns button {
  display: block;
  width: 179px;
  height: 50px;
  font-size: 18px;
  border-radius: 10px;
}

.customer-layer {
  position: absolute;
  right: 0;
  bottom: 90px;
}

.customer-item {
  width: 56px;
  height: 56px;
  background: #272736;
  margin-bottom: 3px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.customer-img {
  display: block;
  width: 19px;
  margin: 8px auto 0;
}

.customer-title {
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  margin-top: 4px;
  font-size: "微软雅黑";
}

.customer-item:nth-of-type(2) .customer-img {
  width: 28px;
}

.wechat-code {
  position: absolute;
  right: 64px;
  top: 0;
  width: 115px;
  height: 115px;
  background: #ffffff;
}

.wechat-code img {
  display: block;
  width: 107px;
  margin: 4px auto 0;
}

.flex-just {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.user-name {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}


// .userNameIpt {
//   border: 1px solid transparent;
// }
// .isEdit {
//   border: 1px solid #DCDFE6;
//   border-radius: 4px;
//   padding: 0 15px;
//   transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
//   width: 134px;
// }
</style>
